// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2bd0351b","120":"ba926f92","488":"fbe40353"}[chunkId] + ".chunk.js";
};